import { ContentType } from '../ContentType';
import { Messages } from '../../../../gen-src/Localize';
import { AppUrls } from '../../../app/AppUrls';
import { CommonColumns, IColumnFactoryParameters } from '../../components/listView/ListViewGridColumnGenerator';
import { ConnectedOwnerFilter } from '../../components/filters/quickFilter/OwnerFilter';
import { IContentDefinition } from './IContentDefinition';
import { DateTimeCell } from '../../components/listView/dataGridCells/DateTimeCells';
import { ConnectedModifiedTimeFilter } from '../../components/filters/quickFilter/ModifiedTimeFilter';
import { GetDataRolesResult } from '../httpClient/MetaDataResults';
import { SearchResponseHitsContent } from '../../../generated/content-exploration';
import { IUser } from '../IUser';
import { DataRole } from '../SearchResultTypes';
import { UserMapper } from '../../../common/utils/UserMapper';
import { LocationTypes } from '../ILocationInfo';
import GetMetaDataRequests from '../../services/httpClient/GetMetaDataRequests';
import { SortBy } from '../SortSelection';
import { defaultHeaderFormatter } from '../../components/listView/DefaultHeaderFormatter';
import { ConnectedTagFilter } from '../../components/filters/quickFilter/TagFilter';

export const dataRoleContentDefinition: IContentDefinition<DataRole, GetDataRolesResult> = {
  getSectionTitle: () => Messages.DataRoleSectionTitle(),
  getUrl: (urls) => urls.searchDataRolesUrl(),
  getPath: (urls) => urls.searchDataRolesPath(),
  mapCRASSData: (crassData: SearchResponseHitsContent[]) => {
    return crassData.map((crassDataItem: SearchResponseHitsContent) => {
      return {
        crassData: crassDataItem,
        contentType: ContentType.datarole,
        name: crassDataItem.title,
        id: crassDataItem.id.toString(),
        location: { name: crassDataItem.containerName || '', id: crassDataItem.projectId?.toString() || '', type: LocationTypes.Project },
        modifiedTime: crassDataItem.modifiedTime || '',
        createdAt: crassDataItem.createdTime || '',
        description: crassDataItem.description || '',
      };
    });
  },
  mapMetadata: (searchResultItems, metadata) => {
    const metaDataUserInfo: { [ownerId: string]: IUser } = {};
    const favoriteMetaData: { [id: string]: boolean } = {};
    if (metadata.total > 0) {
      metadata.items.users.forEach((item) => {
        metaDataUserInfo[item.id] = item;
      });
      metadata.items.favorites.forEach((id) => {
        favoriteMetaData[id] = true;
      });
    }
    return searchResultItems.map((searchResultItem) => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const crassDataItem = searchResultItem.crassData!;
      const user = crassDataItem.ownerId ? metaDataUserInfo[crassDataItem.ownerId] : undefined;
      const owner = UserMapper.mapOne(user);
      return {
        ...searchResultItem,
        owner: owner,
        favorite: favoriteMetaData[crassDataItem.id.toString()] ? favoriteMetaData[crassDataItem.id.toString()] : false,
      };
    });
  },

  defaultDisplayMode: 'list',
  getListViewColumns: () => [
    CommonColumns.name,
    CommonColumns.owner,
    CommonColumns.location,
    (parameters: IColumnFactoryParameters) => {
      return {
        name: 'modified',
        dataKey: 'modifiedTime',
        sortable: false,
        headerText: Messages.column_updated(),
        direction: 'desc',
        headerFormatter: defaultHeaderFormatter(),
        cellFormatter: DateTimeCell('modifiedTime'),
        growToFit: true,
      };
    },
    CommonColumns.description,
  ],
  maxItemCountInMixedContentTypeResultPage: 8,
  contentSpaceUrl: (urls: AppUrls, contentId: string) => urls.dataRoleUrl(contentId),
  quickFilters: [ConnectedOwnerFilter, ConnectedModifiedTimeFilter, ConnectedTagFilter],
  getMetaDataRequests: GetMetaDataRequests.GetDataRoleRequest,
  getSortOptions: () => [SortBy.getRelevancySortSelection()],
  shouldBeAvailable: () => true,
  favoritable: () => true,
};
